/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";
import { Version } from "@shared/components/versions/version.model";

// @formatter:off
@Component({
    standalone: false,
    selector: 'versions',
    templateUrl: './versions.component.html',
    styleUrls: ['./versions.component.scss']
})
// @formatter:on
export class VersionsComponent {
    public version_collapsed: boolean = false;
    @Input() versions: Version[];

    toggleVersion(): void {
        this.version_collapsed = !this.version_collapsed;
    }
}
